import { render } from "./userFormTemp.vue?vue&type=template&id=092f99ca&scoped=true"
import script from "./userFormTemp.vue?vue&type=script&lang=js"
export * from "./userFormTemp.vue?vue&type=script&lang=js"

import "./userFormTemp.vue?vue&type=style&index=0&id=092f99ca&scoped=true&lang=css"

import exportComponent from "/home/accesa/Documents/ACCESA/DANA_PROJECTS/DANA-LITE/dana-lite-registro/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-092f99ca"]])

export default __exports__